module.exports = __webpack_public_path__ + "img/house-person-return.ad5f9784.svg";